const imgTeamGraphic1Poster2 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img2026923382 = "./assets/figma/0742553d-37fd-4197-a5b0-32f0c371bdff.png";
const img2026923372 = "./assets/figma/4035b339-96f6-4927-b1b2-b4d052e226e0.png";
const img2026923373 = "./assets/figma/7a6dc028-9361-4c44-964f-8aa3a1994c16.png";
const img12061 = "./assets/figma/00689bd6-b6e6-499a-a3c6-686dae57eabc.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const img5F7482990599C916Png3 = "./assets/figma/3fc5cadb-ca40-436e-a972-6ee051cf79a4.png";
const img5F7482990599C916Png2 = "./assets/figma/8213bced-c849-4941-9e9d-5aa995b449fa.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/4329ab02-bd1e-473d-8da9-d8ecc919547f.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/46555a1a-7513-434c-85f5-7dfeec719be4.svg";
const imgRectangle247 = "./assets/figma/0a0f13d0-9cdf-414b-9cf7-8d46976f3008.svg";
const imgClose = "./assets/figma/126d0178-fb8f-4298-97a5-6e9219784749.svg";

export default function TeamGraphic1Poster2() {
  return (
    <div className="s0 s1" data-node-id="875:1639" data-name="TEAM_GRAPHIC_1_POSTER2">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s978 s441 s9 s10 s442" src={imgTeamGraphic1Poster2} />
        </div>
      </div>
      <div className="s2 s12 s13 s14 s15" data-node-id="875:1641" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s20 s979 s22" data-node-id="875:1642">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:1643">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1644">
            PROJECT OVERVIEW
          </p>
          <div className="s35 s36 s0 s28 s37 s34 s38" data-node-id="875:1645">
            <p className="s39 s40">
              POSTER · A2 · 2<br aria-hidden />
              BRAND BOOK · B5 · 1
            </p>
            <p className="s39 s40">​</p>
            <p className="s39">​</p>
          </div>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:1646">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:1647">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:1648">
            MEMBERS
          </p>
          <div className="s35 s36 s0 s28 s37 s34" data-node-id="875:1649">
            <p className="s39 s40">강지운</p>
            <p className="s39 s40">김세원</p>
            <p className="s39 s40">노아연</p>
            <p className="s39">정다혜</p>
          </div>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s980 s54" data-node-id="875:1650">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s55 s27 s29 s981 s57" data-node-id="875:1651">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:1652">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:1653">
          <p className="s39 s40">{`그래픽 1팀은 DING AI LAB의 Play Lab 콘셉트와 브랜드 시스템을 포스터와 브랜드북으로 시각화했다. `}</p>
          <p className="s39 s40">
            {`아이디어와 AI가 연결되고 실험되는 과정을 구슬과 투명한 파이프로 표현하고, Play·Flow·Connection·Modular의 네 가지 키워드를 중심으로 `}
            <br aria-hidden />
            {`일관된 브랜드 정체성을 구축했다. 브랜드북에는 8가지 AI별 Tube System과 응용 사례를 담았으며, 구슬이 튜브를 통과하면서 색·질감·형태를 `}
          </p>
          <p className="s39 s40">{`얻고 조합 순서에 따라 다른 결과로 발전하는 과정을 그래픽 시스템으로 구성했다. 오프화이트와 민트 계열의 색상, `}</p>
          <p className="s39">투명한 소재와 구조적인 레이아웃을 적용해 정돈된 실험실 분위기를 완성했다.</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s943 s27 s29 s61 s62 s54" data-node-id="875:1654">
        GRAPHIC 1
      </p>
      <div className="s2 s16 s17 s24 s944 s18 s19 s20 s982 s66" data-node-id="875:1655">
        <p className="s23 s31 s32 s27 s0 s28 s29 s64 s34" data-node-id="875:1656">
          WORK
        </p>
        <div className="s16 s17 s18 s19 s36 s0 s28 s34" data-node-id="875:1657">
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1658">
            <div className="s192 s69 s659 s340 s0 s70 s198 s348 s71" data-node-id="875:1659" data-name="이미지 2026. 9. 2. 오후 3.38 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1660" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1661" />
            <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:1662">
              POSTER 1
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1663">
            <div className="s192 s69 s946 s340 s0 s70 s198 s348 s71" data-node-id="875:1664" data-name="이미지 2026. 9. 2. 오후 3.37 2">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923372} />
              </div>
            </div>
            <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:1665" />
            <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:1666" />
            <p className="s23 s192 s31 s94 s947 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:1667">
              POSTER 2
            </p>
          </div>
          <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:1668">
            <div className="s192 s69 s339 s340 s0 s70 s198 s348 s71" data-node-id="875:1669" data-name="이미지 2026. 9. 2. 오후 3.37 3">
              <div className="s2 s3 s6 s4 s70">
                <img alt="" className="s2 s7 s948 s9 s10 s949" src={img2026923373} />
              </div>
            </div>
            <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:1670" />
            <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:1671" />
            <p className="s23 s192 s31 s94 s950 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:1672">
              CATALOG
            </p>
          </div>
        </div>
      </div>
      <div className="s2 s951 s328 s981 s952" data-node-id="875:1673" data-name="이미지 1206 1">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12061} />
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:1674">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s107 s108 s109" data-node-id="875:1675" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:1676">
          <div className="s111 s0 s28 s112" data-node-id="875:1677" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:1682">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:1683">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:1684">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1685">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1686">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:1687">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1688">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1689">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:1690">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:1691">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:1692">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:1765">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:1766">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:1772" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
        <p className="s23 s31 s32 s27 s0 s28 s137 s138 s54" data-node-id="875:1773">
          GRAPHIC 1
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="772:1342" data-name="PROJECT_CATEGORY_TABS_GRAPHIC1">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="772:1343" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="772:1344">
              POSTER1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="772:1345" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="772:1346">
              POATER2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="772:1347" data-name="TAB_CATALOG">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="772:1348">
              CATALOG
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <div className="s106 s2 s67 s126 s983" data-node-id="875:1761">
        <div className="s2 s5 s984 s153 s156 s157 s983 s158" data-node-id="856:2762" />
        <p className="s23 s2 s31 s32 s985 s27 s29 s160 s986 s54" data-node-id="856:2763">
          POSTER2
        </p>
        <div className="s106 s2 s67 s987 s988" data-node-id="856:2772">
          <div className="s106 s2 s989 s987 s165 s4 s145 s146 s988 s990" data-node-id="856:2773">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s991 s26 s992 s27 s29 s993 s994" data-node-id="856:2774">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2775">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2776">
                Prompt
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2777">
                DING AI LAB의 8가지 AI 튜브가 하나의 원형 허브에 연결된 이미지를 만들어줘. 중앙에 회색 원형 허브를 배치하고, 주변으로 ChatGPT의 직선형, Claude의 반복형, Gemini의 물결형, Midjourney의 나선형, Grok의 U자형, Runway의 순환형, Higgsfield의 다층 루프형, Manus의 분기형 튜브가 뻗어나가도록 구성해줘.튜브는 회색·주황·파랑·분홍·올리브·라임·민트 계열로 구분하고, 중앙 연결부에는 동일한 회색 커넥터를 사용해줘. 관의 두께는 일정하게 유지하고 서로 겹치지 않도록 수직·수평 중심으로 정돈해줘.화이트와 옅은 민트 배경, 반투명한 유리 재질과 은은한 그림자를 활용해 심플하고 세련된 실험실 분위기로 표현해줘. B5 가로형 비율로 제작하고 글자·로고·아이콘·구슬은 제외해줘.
              </p>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2778">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2779">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2780">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s106 s2 s67 s131 s995" data-node-id="856:2781">
          <div className="s106 s2 s989 s131 s165 s4 s145 s146 s995 s990" data-node-id="856:2782">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s991 s26 s996 s27 s29 s997 s994" data-node-id="856:2783">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2784">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2785">
                Prompt
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2786">
                첫 번째 이미지의 중앙 원형 허브와 8가지 컬러 튜브 구조를 유지하면서, B5 가로형 두 페이지를 연결한 펼침면으로 다시 디자인해줘. 전체 크기는 514×182mm, 약 2.82:1 비율로 설정하고 이미지를 단순히 가로로 늘리면 안 돼.원형 허브의 중심을 전체 펼침면의 정중앙에 정확히 배치하고, 각 튜브의 긴 직선 구간을 좌우 끝까지 자연스럽게 연장해 넓은 화면을 채워줘. 직선·반복·물결·나선·U자·순환·다층 루프·분기형 특징과 기존 컬러는 유지하되, 관의 두께와 굴곡이 달라지거나 형태가 찌그러지지 않게 해줘.튜브 위의 흰색 구슬과 원형 마커는 모두 제거하고, 오프화이트 배경과 반투명한 유리 재질, 회색 커넥터만 유지해줘. 글자·로고·아이콘은 넣지 말아줘.
              </p>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2787">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2788">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2789">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s106 s2 s67 s998 s999" data-node-id="856:2790">
          <div className="s106 s2 s1000 s998 s165 s4 s145 s146 s999 s990" data-node-id="856:2791">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s991 s26 s1001 s27 s29 s1002 s994" data-node-id="856:2792">
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2793">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2794">
                Prompt
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2795">
                DING AI LAB의 8가지 AI Tube를 하나의 중앙 원형 튜브에 연결한 키비주얼 이미지를 제작해.ChatGPT의 직선형은 회색, Claude의 반복형은 주황색, Gemini의 물결형은 파란색, Midjourney의 나선형은 분홍색, Grok의 U자형은 짙은 회색, Runway의 순환형은 올리브색, Higgsfield의 다층 루프형은 라임색, Manus의 분기형은 민트색으로 표현해.모든 튜브는 중앙의 회색 원형과 회색 커넥터로 연결하고, 관의 굵기는 일정하게 유지해. 튜브끼리 겹치거나 복잡하게 얽히지 않도록 수직·수평 중심으로 정리하고, 각 AI 튜브의 특징은 복잡하지 않게 간결하게 보여줘.화이트와 아주 옅은 민트 배경, 반투명한 파스텔 유리관, 은은한 입자감과 부드러운 그림자를 사용해 깔끔하고 세련된 실험실 분위기로 만들어.B5 가로형 두 페이지를 연결한 514×182mm 비율로 제작하고, 중앙 원형 허브는 펼침면 정가운데에 배치해. 관 위에 구슬이나 흰색 원형 마커는 넣지 말고, 글자·로고·아이콘도 제외해.
              </p>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:2796">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:2797">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:2798">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s957 s396 s1003 s960" data-node-id="856:2799" data-name="5f7482990599c916.png 3">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={img5F7482990599C916Png3} />
        </div>
        <div className="s2 s1004 s189 s1005 s1006" data-node-id="856:2801" data-name="5f7482990599c916.png 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s1007 s1008 s9 s1009 s1010" src={img5F7482990599C916Png2} />
          </div>
        </div>
        <div className="s2 s1011 s1012 s995 s1013" data-node-id="856:2802" data-name="5f7482990599c916.png 3">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s1014 s1015 s9 s1016 s1010" src={img5F7482990599C916Png2} />
          </div>
        </div>
        <div className="s2 s1017 s396 s999 s1018" data-node-id="856:2803" data-name="5f7482990599c916.png 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s1019 s1020 s9 s1021 s1022" src={img5F7482990599C916Png2} />
          </div>
        </div>
        <p className="s23 s2 s31 s32 s715 s27 s29 s137 s1023 s54" data-node-id="856:2804">
          PROCESS
        </p>
      </div>
      <div className="s2 s961 s1024 s1025 s963" data-node-id="856:2800" data-name="5f7482990599c916.png 2">
        <div className="s2 s3 s6 s4">
          <img alt="" className="s2 s1026 s1027 s9 s1028 s1029" src={img5F7482990599C916Png2} />
        </div>
      </div>
      <button className="s2 s49 s141 s211 s212 s213" data-node-id="891:142" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}